import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export type Unit = {
  id: string;
  name: string;
  type: 'battalion' | 'company';
  parentId?: string;
};
export const unitData: Unit[] = [{
  id: 'all',
  name: 'All Units',
  type: 'battalion'
}, {
  id: '1bn',
  name: '1st Battalion',
  type: 'battalion'
}, {
  id: 'alpha',
  name: 'Alpha Company',
  type: 'company',
  parentId: '1bn'
}, {
  id: 'bravo',
  name: 'Bravo Company',
  type: 'company',
  parentId: '1bn'
}, {
  id: '2bn',
  name: '2nd Battalion',
  type: 'battalion'
}, {
  id: 'charlie',
  name: 'Charlie Company',
  type: 'company',
  parentId: '2bn'
}, {
  id: 'delta',
  name: 'Delta Company',
  type: 'company',
  parentId: '2bn'
}, {
  id: '3bn',
  name: '3rd Battalion',
  type: 'battalion'
}, {
  id: 'echo',
  name: 'Echo Company',
  type: 'company',
  parentId: '3bn'
}];
interface UnitFilterProps {
  selectedUnitId: string;
  onUnitChange: (unitId: string) => void;
}
export const UnitFilter: React.FC<UnitFilterProps> = ({
  selectedUnitId,
  onUnitChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedUnit = unitData.find(unit => unit.id === selectedUnitId) || unitData[0];
  const toggleDropdown = () => setIsOpen(!isOpen);
  return <div className="relative" data-id="element-1065">
      <button onClick={toggleDropdown} className="flex items-center justify-between w-64 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1066">
        <span data-id="element-1067">{selectedUnit.name}</span>
        <ChevronDownIcon className="w-4 h-4 ml-2" data-id="element-1068" />
      </button>
      {isOpen && <div className="absolute right-0 z-10 mt-1 w-64 bg-white rounded-md shadow-lg border border-gray-200" data-id="element-1069">
          <ul className="py-1 max-h-60 overflow-auto" data-id="element-1070">
            {unitData.map(unit => <li key={unit.id} onClick={() => {
          onUnitChange(unit.id);
          setIsOpen(false);
        }} className={`${unit.type === 'battalion' ? 'font-medium' : 'pl-6'} ${selectedUnitId === unit.id ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'} px-4 py-2 text-sm cursor-pointer`} data-id="element-1071">
                {unit.name}
              </li>)}
          </ul>
        </div>}
    </div>;
};